import { __rest, __assign } from 'tslib';
import React__default, { Suspense, useMemo, useEffect } from 'react';
import { activeBusinessFiltersState, useDataView, useKeyboardSelection, dataViewSize, ELEMENT_SUMMARY_ID_PREFIX, isClientSide, fetcherModeAtom, dataviewElementFetcherSelector, dataViewMasonryDisplaySize, QueryParamElement } from '@keepeek/commons';
import { Box } from '@mui/material';
import clsx from 'clsx';
import { useRecoilValue } from 'recoil';
import { withSuspense } from '../../../withSuspense/index.js';
import { KGridMode } from '../../KGrid/index.js';
import MemoizedElementSummary from '../../MemoizedElementSummary/index.js';
import { MasonryDataViewLoading } from './MasonryDataViewLoading.js';

var MAX_IMAGE_HEIGHT = "400px";
var MasonryViewWithSuspense = function (_a) {
    var className = _a.className, KGrid = _a.KGrid, dataViewKey = _a.dataViewKey, props = __rest(_a, ["className", "KGrid", "dataViewKey"]);
    return (React__default.createElement(Box, { className: clsx("MasonryDataView", className) },
        React__default.createElement(Suspense, { fallback: React__default.createElement(MasonryDataViewLoading, { KGrid: KGrid, dataViewKey: dataViewKey }) },
            React__default.createElement(MasonryDataView, __assign({ KGrid: KGrid, dataViewKey: dataViewKey }, props)))));
};
var MasonryDataView = function (_a) {
    var KIcon = _a.KIcon, KGrid = _a.KGrid, goToPageWithBackContext = _a.goToPageWithBackContext, sentryCallback = _a.sentryCallback, shareTokenDownloadAuthorized = _a.shareTokenDownloadAuthorized, allowSelection = _a.allowSelection, allowNavigation = _a.allowNavigation, onDataViewFirstRender = _a.onDataViewFirstRender, dataViewKey = _a.dataViewKey, onElementDoubleClick = _a.onElementDoubleClick, onElementActionClick = _a.onElementActionClick, enabledActions = _a.enabledActions, actionButtonsColor = _a.actionButtonsColor, attachmentsVisible = _a.attachmentsVisible;
    var filters = useRecoilValue(activeBusinessFiltersState(dataViewKey));
    var elements = useDataView({ key: dataViewKey, filters: filters || null }).elements;
    useKeyboardSelection(dataViewKey, elements, allowSelection);
    var size = useRecoilValue(dataViewSize(dataViewKey));
    var sizeArray = useMemo(function () { return Array(Math.min(size, elements.length)).fill(null); }, [elements.length, size]);
    // Client scroll on element
    useEffect(function () {
        var hasHash = window.location.hash.split(ELEMENT_SUMMARY_ID_PREFIX);
        if (hasHash.length === 2 && isClientSide()) {
            var elementId = hasHash[1];
            var domEl = document.getElementById("element-".concat(elementId));
            if (domEl === null || domEl === void 0 ? void 0 : domEl.offsetTop) {
                window.scrollTo({ top: domEl === null || domEl === void 0 ? void 0 : domEl.offsetTop, behavior: "smooth" });
            }
        }
    }, []);
    useEffect(function () {
        onDataViewFirstRender && onDataViewFirstRender();
    }, [onDataViewFirstRender]);
    var mode = useRecoilValue(fetcherModeAtom);
    var getElementBackContext = useRecoilValue(dataviewElementFetcherSelector(mode)).getElementBackContext;
    var dataviewMasonrySize = useRecoilValue(dataViewMasonryDisplaySize(dataViewKey));
    return (React__default.createElement(KGrid, { id: "MasonryDataView", mode: KGridMode.Masonry, masonryViewSize: dataviewMasonrySize }, sizeArray.map(function (_p, i) { return (React__default.createElement(Box, { id: "element-".concat(elements && elements.length > i ? elements[i].id : 0), key: i },
        React__default.createElement(MemoizedElementSummary, { useImgComponent: true, id: elements && elements.length > i ? elements[i].id : 0, showFields: false, shareTokenDownloadAuthorized: shareTokenDownloadAuthorized, key: dataViewKey, enabledActions: enabledActions, sentryCallback: sentryCallback, openElementCallback: function (_a) {
                var elementId = _a.elementId, options = _a.options;
                if (options === null || options === void 0 ? void 0 : options.highlightAssociations) {
                    goToPageWithBackContext({
                        sourcePage: { pathname: "/search" },
                        targetPage: {
                            pathname: "/element",
                            query: { id: elementId, mode: QueryParamElement.HIGHLIGHT_ASSOCIATIONS }
                        }
                    });
                }
                else {
                    goToPageWithBackContext(getElementBackContext(elementId));
                }
            }, KIcon: KIcon, allowSelection: allowSelection, allowNavigation: allowNavigation, dataViewKey: dataViewKey, onActionClick: function (action) { return onElementActionClick(elements[i].id, action); }, onDoubleClick: function () { return onElementDoubleClick(elements[i].id); }, children: null, imageMaxHeight: MAX_IMAGE_HEIGHT, actionButtonsColor: actionButtonsColor, attachmentsVisible: attachmentsVisible }))); })));
};
var MasonryDataView$1 = withSuspense(MasonryViewWithSuspense);

export { MasonryDataView$1 as default };
//# sourceMappingURL=index.js.map
